import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ConversionRuleRBAC = {
  pageID: 'e3038ac4d9cd647d99dfc99597a5e073',
  elementID: {
    TableList: 'b25c73b0adb89226eba11c1494f0f6e1',
    BtnAddRule: '971b171bbf1b629736a9d0eb75c69040',
    BtnEditRule: '4efc266bf9b25010550340b0679486f3',
    BtnDeleteRule: '307b58ad809a932f23f38b1e3fedde52',
  },
} as const

export const useRBACConversionRule = createUseRBAC(ConversionRuleRBAC.elementID)

export type UseRBACConversionRuleType = ReturnType<typeof useRBACConversionRule>
